import { lazy } from "react";

const Logout = lazy(() => import("./index"));

export const LogoutUrls = [{ link: "/logout", component: Logout }];